import React from "react";
import Paper from "@mui/material/Paper";
import Divider from "@mui/material/Divider";
import { backdropClasses, Stack, touchRippleClasses } from "@mui/material";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import Button from '@mui/material/Button';
import { StyledButtonTeal } from "../components/styled_button";


const topbar_styles = {
  display: "flex",
  position: "fixed",
  top: 0,
  width: "100%",
  height: "3rem",
  backgroundColor: "none",
  color: "rgba(0, 0, 0, 0.75)",
  justifyContent: "space-between",
  alignItems: "center",
  zIndex: 100
};

const logo_styles = {
  fontSize: "1.3rem",
  fontFamily: "Fjalla One",
  marginLeft: "0.5rem",
  letterSpacing: "0.02rem",
};

const title_styles = {
  fontSize: "1.5rem",
  fontFamily: "ChalkboardSE-Regular",
  letterSpacing: "0rem",
  fontWeight: "bold",
};

const user_styles = {
  fontSize: "1.3rem",
  fontFamily: "ChalkboardSE-Regular",
  paddingRight: "0.5rem",
  letterSpacing: "0.02rem",
};

const icon_styles = {
  fontSize: "1.7rem",
  color: "rgba(0, 0, 0, 0.75)",
  paddingRight: "0.5rem",
};

export default class Topbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      title: props.title,
      logo: "Constems-AI",
      user_icon: props.user_icon,
    };

    this.onChange = this.onChange.bind(this);
  }

  onChange(e) {
    this.setState({
      data: e,
    });
  }

  componentDidMount() { }

  render() {
    const title = this.state.title;
    // const user = this.state.user;
    const logo = this.state.logo;
    const user_icon = this.state.user_icon;

    const user = sessionStorage.getItem("user");

    return (
      <Paper elevation={3} style={topbar_styles}>
        <span style={logo_styles}>{logo}</span>
        <span style={title_styles}>{title}</span>
        <Stack direction="row" spacing={1}>
          <span style={user_styles}>{user}</span>
          {/* {user_icon && <PersonOutlineIcon sx={icon_styles} />} */}
        </Stack>
      </Paper>
    );
  }
}
